import { FETCH_ALL_STORAGE_DESTINATION_SUCCEEDED, FETCH_ALL_PRODUCT_LOCATION_SUCCEEDED, FETCH_ALL_LOCATION_LAST_TRACK_SUCCEEDED } from './storage.action';
import {} from './product.action';
import * as _ from 'lodash';

const Location = (state = { products: [] }, action) => {
  switch (action.type) {
    case FETCH_ALL_PRODUCT_LOCATION_SUCCEEDED:
      return _.assign(state, {
        products: _.filter(action.data, item => item.getLocationId() === (state as any).getId())
      });
    case FETCH_ALL_LOCATION_LAST_TRACK_SUCCEEDED:
      return _.assign(state, {
        last_track: _.find(action.data, item => item.getLocationId() === (state as any).getId())
      });
    default:
      return state;
  }
};
const Destination = (state = { locations: [] }, action) => {
  switch (action.type) {
    case FETCH_ALL_PRODUCT_LOCATION_SUCCEEDED:
      return _.assign(state, {
        products: _.filter(action.data, item => item.getDestinationId() === (state as any).getId()),
        locations: _.map(state.locations, location => Location(location, action))
      });
    case FETCH_ALL_LOCATION_LAST_TRACK_SUCCEEDED:
      return _.assign(state, {
        locations: _.map(state.locations, location => Location(location, action))
      });
    default:
      return state;
  }
};

export const storage = (state = { fetched: false, items: [], updated: false }, action) => {
  switch (action.type) {
    case FETCH_ALL_STORAGE_DESTINATION_SUCCEEDED:
      return _.assign({}, state, {
        fetched: true,
        items: action.data
      });
    case FETCH_ALL_PRODUCT_LOCATION_SUCCEEDED:
    case FETCH_ALL_LOCATION_LAST_TRACK_SUCCEEDED:
      return _.assign({}, state, {
        items: _.map(state.items, destination => Destination(destination, action))
      });
    default:
      return state;
  }
};
